exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-dialog-actions {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n\nmd-form-field {\n    width: 100%\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/components/info-dialog/info-dialog.component.css
// module id = ../../../../../src/app/components/info-dialog/info-dialog.component.css
// module chunks = main